module.exports = __webpack_public_path__ + "717b777051b441c945070e21e9d7b656.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/padNumberDelete.png
// module id = 327
// module chunks = 0